import { create } from 'zustand'
import { SportListingType } from 'types/listing/listings'

const sportCreationState = (set: any) => ({
  addSportModal: false,
  setAddSportModal: (state: boolean) => set(() => ({ addSportModal: state })),
  sportData: null,
  setSportData: (state: SportListingType) => set(() => ({ sportData: state })),
})

export const sportCreationStore = create(sportCreationState)
